import {
    ACTION_LIST_CLIENTS,
    ACTION_DETAIL_CLIENT,
    ACTION_UPDATE_CLIENT,
    ACTION_DIALOG_ACTIVE,
    SET_CLIENTS,
    SET_DETAIL_CLIENT,
    SET_DIALOG_ACTIVE
} from '@/views/clients/store/types/types.js'

import config from '@/views/clients/config/client_api.js';
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';

const _pathUri = new PathUri(config.port, config.context, '/empresas/');

const _service = `${config.baseUrl}${_pathUri.generateUri()}`;

const actions = {
    [ACTION_LIST_CLIENTS]: ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            state.loading = true;

            axios.get(_service)
                .then(resp => {
                    const clients = resp.data.map((e, i) => ({
                        ...e,
                        activeDialogClient: false,
                        index: i
                    }));
                    commit(SET_CLIENTS, clients);
                    resolve(resp.data)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => state.loading = false);
        })
    },
    [ACTION_DIALOG_ACTIVE]: ({ commit }, data) => {
        commit(SET_DIALOG_ACTIVE, data);
    },

    [ACTION_DETAIL_CLIENT]: ({ state, commit }, idEmpresa) => {
        return new Promise((resolve, reject) => {
            state.loading = true;
            const service = `${_service}${idEmpresa}`;
            axios.get(service)
                .then(resp => {
                    const detailClient = resp.data;
                    commit(SET_DETAIL_CLIENT, detailClient);
                    resolve(resp.data)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => state.loading = false);
        })
    },


    [ACTION_UPDATE_CLIENT]: ({ dispatch }, payload) => {

        return new Promise((resolve, reject) => {

            const service = `${_service}actualizar`;

            axios.post(service, payload)
                .then(async(resp) => {
                    await dispatch(ACTION_DETAIL_CLIENT, payload.idEmpresa);
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
};
export default actions;